import React from 'react';
import { formatMessage } from '@99designs/frontend-components/i18n';
import Attribution from '../../../../../shared/components/Attribution';
import AvatarPlaceholder from '../../../../../shared/components/AvatarPlaceholder';
import AvatarWithAttribution from '../../../../../shared/components/AvatarWithAttribution';
import Blockquote from '../../../../../shared/components/Blockquote';
import Box from '../../../../../shared/components/Box';
import Heading from '../../../../../shared/components/Heading';
import StarRating from '../../../../../shared/components/StarRating';
import TruncateText from '../../../../../shared/components/TruncateText';
import { ReviewType } from '../../ContestOverviewData';

interface Props {
    review?: ReviewType;
}

// TODO: connect this ratings data post MVP.
const avgDesignerRating = 4.8;
const avgDesignerRatingCount = 40000;

export default function ClientReview({ review }: Props) {
    let reviewersName = '';
    if (review && review.reviewer && review.reviewer.displayName) {
        reviewersName = review.reviewer.displayName;
    }
    if (review && review.anonymous) {
        reviewersName = __('Anonymous');
    }

    return (
        <Box paddingTop={['space12', 'space12', 'space16', 'space16']}>
            {review ? (
                <>
                    <Heading type="h5" variations={['h5', 'soft']}>
                        {__('Client review')}
                    </Heading>
                    <StarRating rating={review.rating} />
                    <Box paddingTop={['space7', 'space7', 'space7', 'space7']}>
                        <Heading type="h3" variations={['h2']}>
                            <Blockquote
                                quote={
                                    <TruncateText text={review.message.trim()} maxHeight={300} />
                                }
                            />
                        </Heading>
                        {reviewersName && (
                            <AvatarWithAttribution
                                avatar={<AvatarPlaceholder size="extra-small" />}
                                attribution={
                                    <Attribution
                                        name={reviewersName}
                                        hasPreposition={false}
                                        size="root"
                                    />
                                }
                            />
                        )}
                    </Box>
                </>
            ) : (
                <>
                    <Heading type="h2" variations={['h5', 'soft']}>
                        {__('Client reviews')}
                    </Heading>
                    <StarRating rating={avgDesignerRating} />
                    <Box paddingTop={['space7', 'space7', 'space7', 'space7']}>
                        <Heading type="h3" variations={['h2']}>
                            {formatMessage(
                                __('{rating} average from over {count} design contest ratings'),
                                {
                                    rating: avgDesignerRating,
                                    count: avgDesignerRatingCount,
                                }
                            )}
                        </Heading>
                    </Box>
                </>
            )}
        </Box>
    );
}
